export type ZoneOption = {
  timeZone: string;
  city: string;
  country: string;
  aliases?: string[];
};

export const featuredZones: ZoneOption[] = [
  { timeZone: "Etc/UTC", city: "UTC", country: "Coordinated Universal Time", aliases: ["GMT"] },
  { timeZone: "Pacific/Honolulu", city: "Honolulu", country: "United States", aliases: ["Hawaii", "HST"] },
  { timeZone: "America/Anchorage", city: "Anchorage", country: "United States", aliases: ["Alaska"] },
  { timeZone: "America/Los_Angeles", city: "Los Angeles", country: "United States", aliases: ["San Francisco", "Seattle", "Pacific", "PST", "PDT"] },
  { timeZone: "America/Vancouver", city: "Vancouver", country: "Canada", aliases: ["Pacific"] },
  { timeZone: "America/Denver", city: "Denver", country: "United States", aliases: ["Mountain", "MST", "MDT"] },
  { timeZone: "America/Phoenix", city: "Phoenix", country: "United States", aliases: ["Arizona", "MST"] },
  { timeZone: "America/Chicago", city: "Chicago", country: "United States", aliases: ["Dallas", "Houston", "Central", "CST", "CDT"] },
  { timeZone: "America/Mexico_City", city: "Mexico City", country: "Mexico", aliases: ["CDMX"] },
  { timeZone: "America/Toronto", city: "Toronto", country: "Canada", aliases: ["Eastern"] },
  { timeZone: "America/New_York", city: "New York", country: "United States", aliases: ["Boston", "Miami", "Washington", "Eastern", "EST", "EDT"] },
  { timeZone: "America/Halifax", city: "Halifax", country: "Canada", aliases: ["Atlantic"] },
  { timeZone: "America/Sao_Paulo", city: "São Paulo", country: "Brazil", aliases: ["Sao Paulo", "Brasilia"] },
  { timeZone: "America/Argentina/Buenos_Aires", city: "Buenos Aires", country: "Argentina" },
  { timeZone: "America/Santiago", city: "Santiago", country: "Chile" },
  { timeZone: "America/Bogota", city: "Bogotá", country: "Colombia", aliases: ["Bogota"] },
  { timeZone: "America/Lima", city: "Lima", country: "Peru" },
  { timeZone: "Atlantic/Reykjavik", city: "Reykjavík", country: "Iceland", aliases: ["Reykjavik", "GMT"] },
  { timeZone: "Europe/London", city: "London", country: "United Kingdom", aliases: ["GMT", "BST"] },
  { timeZone: "Europe/Dublin", city: "Dublin", country: "Ireland" },
  { timeZone: "Europe/Lisbon", city: "Lisbon", country: "Portugal" },
  { timeZone: "Europe/Paris", city: "Paris", country: "France", aliases: ["CET", "CEST"] },
  { timeZone: "Europe/Berlin", city: "Berlin", country: "Germany", aliases: ["Frankfurt", "Munich", "CET", "CEST"] },
  { timeZone: "Europe/Amsterdam", city: "Amsterdam", country: "Netherlands" },
  { timeZone: "Europe/Brussels", city: "Brussels", country: "Belgium" },
  { timeZone: "Europe/Madrid", city: "Madrid", country: "Spain" },
  { timeZone: "Europe/Rome", city: "Rome", country: "Italy" },
  { timeZone: "Europe/Zurich", city: "Zurich", country: "Switzerland" },
  { timeZone: "Europe/Stockholm", city: "Stockholm", country: "Sweden" },
  { timeZone: "Europe/Warsaw", city: "Warsaw", country: "Poland" },
  { timeZone: "Europe/Athens", city: "Athens", country: "Greece", aliases: ["EET", "EEST"] },
  { timeZone: "Europe/Helsinki", city: "Helsinki", country: "Finland" },
  { timeZone: "Europe/Kyiv", city: "Kyiv", country: "Ukraine", aliases: ["Kiev"] },
  { timeZone: "Europe/Istanbul", city: "Istanbul", country: "Türkiye", aliases: ["Turkey"] },
  { timeZone: "Europe/Moscow", city: "Moscow", country: "Russia" },
  { timeZone: "Africa/Cairo", city: "Cairo", country: "Egypt" },
  { timeZone: "Africa/Johannesburg", city: "Johannesburg", country: "South Africa", aliases: ["Cape Town"] },
  { timeZone: "Africa/Nairobi", city: "Nairobi", country: "Kenya" },
  { timeZone: "Asia/Jerusalem", city: "Jerusalem", country: "Israel", aliases: ["Tel Aviv"] },
  { timeZone: "Asia/Dubai", city: "Dubai", country: "United Arab Emirates", aliases: ["UAE"] },
  { timeZone: "Asia/Riyadh", city: "Riyadh", country: "Saudi Arabia" },
  { timeZone: "Asia/Tehran", city: "Tehran", country: "Iran" },
  { timeZone: "Asia/Karachi", city: "Karachi", country: "Pakistan" },
  { timeZone: "Asia/Kolkata", city: "Mumbai", country: "India", aliases: ["Delhi", "Bangalore", "Bengaluru", "Calcutta", "IST"] },
  { timeZone: "Asia/Dhaka", city: "Dhaka", country: "Bangladesh" },
  { timeZone: "Asia/Bangkok", city: "Bangkok", country: "Thailand" },
  { timeZone: "Asia/Jakarta", city: "Jakarta", country: "Indonesia" },
  { timeZone: "Asia/Singapore", city: "Singapore", country: "Singapore", aliases: ["SGT"] },
  { timeZone: "Asia/Kuala_Lumpur", city: "Kuala Lumpur", country: "Malaysia" },
  { timeZone: "Asia/Ho_Chi_Minh", city: "Ho Chi Minh City", country: "Vietnam", aliases: ["Saigon"] },
  { timeZone: "Asia/Manila", city: "Manila", country: "Philippines" },
  { timeZone: "Asia/Hong_Kong", city: "Hong Kong", country: "Hong Kong", aliases: ["HKT"] },
  { timeZone: "Asia/Shanghai", city: "Shanghai", country: "China", aliases: ["Beijing", "Guangzhou", "Shenzhen", "CST"] },
  { timeZone: "Asia/Taipei", city: "Taipei", country: "Taiwan" },
  { timeZone: "Asia/Seoul", city: "Seoul", country: "South Korea", aliases: ["KST"] },
  { timeZone: "Asia/Tokyo", city: "Tokyo", country: "Japan", aliases: ["Osaka", "JST"] },
  { timeZone: "Australia/Perth", city: "Perth", country: "Australia" },
  { timeZone: "Australia/Adelaide", city: "Adelaide", country: "Australia" },
  { timeZone: "Australia/Brisbane", city: "Brisbane", country: "Australia" },
  { timeZone: "Australia/Sydney", city: "Sydney", country: "Australia", aliases: ["Melbourne"] },
  { timeZone: "Pacific/Auckland", city: "Auckland", country: "New Zealand" },
];

function titleCase(value: string) {
  return value
    .replaceAll("_", " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function zoneFromIana(timeZone: string): ZoneOption {
  const known = featuredZones.find((zone) => zone.timeZone === timeZone);
  if (known) return known;

  const segments = timeZone.split("/");
  return {
    timeZone,
    city: titleCase(segments.at(-1) ?? timeZone),
    country: titleCase(segments.slice(0, -1).join(" · ") || "Time zone"),
  };
}

export function getAllZones(): ZoneOption[] {
  const intlWithZones = Intl as unknown as {
    supportedValuesOf?: (key: "timeZone") => string[];
  };
  const supported = intlWithZones.supportedValuesOf?.("timeZone") ?? [];
  const byName = new Map(featuredZones.map((zone) => [zone.timeZone, zone]));

  supported.forEach((timeZone) => {
    if (!byName.has(timeZone)) byName.set(timeZone, zoneFromIana(timeZone));
  });

  return [...byName.values()].sort((a, b) => a.city.localeCompare(b.city));
}

export function searchZones(query: string, limit = 80): ZoneOption[] {
  const normalized = query.trim().toLocaleLowerCase();
  if (!normalized) return featuredZones.slice(0, 18);

  return getAllZones()
    .map((zone) => {
      const fields = [zone.city, zone.country, zone.timeZone, ...(zone.aliases ?? [])].map((value) =>
        value.toLocaleLowerCase(),
      );
      const starts = fields.some((value) => value.startsWith(normalized));
      const includes = fields.some((value) => value.includes(normalized));
      return { zone, score: starts ? 0 : includes ? 1 : 2 };
    })
    .filter(({ score }) => score < 2)
    .sort((a, b) => a.score - b.score || a.zone.city.localeCompare(b.zone.city))
    .slice(0, limit)
    .map(({ zone }) => zone);
}
